
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SYNC_COOKIE_USER_DATA = 'SYNC_COOKIE_USER_DATA';

export const UPDATE_REGISTRATION_SCREEN_TIME = 'UPDATE_REGISTRATION_SCREEN_TIME';
export const SYNC_COOKIE_REGISTRATION_SCREEN_TIME = 'SYNC_COOKIE_REGISTRATION_SCREEN_TIME';

export const UPDATE_WELCOME_SCREEN_TIME = 'UPDATE_WELCOME_SCREEN_TIME';
export const SYNC_COOKIE_WELCOME_SCREEN_TIME = 'SYNC_COOKIE_WELCOME_SCREEN_TIME';
